import { useParams } from "react-router";
import { RetireCompanyConfigForm } from "../components";

interface RetireCompanyConfigScreenProps {
  presentation?: "legacy" | "redesign";
  configurationBasePath?: string;
}

/**
 * Retire a specific version of a company configuration
 * (`/onboarding/:configCode/versions/:version/retire`).
 */
export function RetireCompanyConfigScreen({
  presentation = "redesign",
  configurationBasePath = "/onboarding",
}: RetireCompanyConfigScreenProps) {
  const { configCode, version } = useParams<{
    configCode: string;
    version: string;
  }>();

  const parsedVersion = Number(version);

  // Versions are 1-based, so reject 0 and negatives (as well as non-integers)
  // to avoid sending bad requests to the retire hook.
  if (!configCode || !Number.isInteger(parsedVersion) || parsedVersion < 1) {
    return <div role="alert">Invalid company configuration version.</div>;
  }

  return (
    <RetireCompanyConfigForm
      configCode={configCode}
      version={parsedVersion}
      presentation={presentation}
      configurationBasePath={configurationBasePath}
    />
  );
}
